import React from 'react';
import { faLock, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import { iam_ip } from "../../utils/ip_details";
import { Formik } from 'formik';
import * as yup from 'yup';
import { call_post_api }  from "../../utils/event_handling";
import Image from '../../components/image';
import {browserHistory} from 'react-router';


class ResetForm extends React.Component {
    constructor(props) {
        super(props);
        this.changePasswordIcon = this.changePasswordIcon.bind(this);
        this.setPassword = this.setPassword.bind(this);
        this.hideAlert = this.hideAlert.bind(this);
        this.disableButton = this.disableButton.bind(this);
        this.changeConfirmPasswordIcon = this.changeConfirmPasswordIcon.bind(this);
        this.state = {
            formValid: false,
            hideSubmitButton: false,
            errorCount: null,
            errors: '',
            passwordIcon: faEye,
            passwordType: "password",
            confirmPasswordIcon: faEye,
            confirmPasswordType: "password",
            successMessage: false,
        };

    }


    setPassword(event) {
            this.disableButton();
            const {password} = event;
            const passwordData = {password:password};
            let token = localStorage.getItem('resetPwdToken');
            call_post_api(iam_ip, 'set-password?token='+token, passwordData).then((response) => {
                localStorage.removeItem("resetPwdToken");
                if (response.code === 200) {
                    this.setState({successMessage: true});
                } else {
                    this.setState({errors:response.message,hideSubmitButton: false});
                }
            });

    }

    disableButton() {
        this.setState({hideSubmitButton: true});
    }

    changePasswordIcon() {
        let state = this.state.passwordIcon;
        if (state.iconName === "eye") {
          this.setState({passwordIcon: faEyeSlash});
          this.setState({passwordType: "text"})
        } else {
          this.setState({passwordIcon: faEye});
          this.setState({passwordType: "password"})
        }

    }

    changeConfirmPasswordIcon() {
        let state = this.state.confirmPasswordIcon;
        if (state.iconName === "eye") {
          this.setState({confirmPasswordIcon: faEyeSlash});
          this.setState({confirmPasswordType: "text"});
        } else {
          this.setState({confirmPasswordIcon: faEye});
          this.setState({confirmPasswordType: "password"});
        }

    }

    gotoLogin() {
        browserHistory.push("/");
    }

    hideAlert() {
        this.setState({
          errors: '',
        });
    }

    render() {
        const setSchema = yup.object({
            password: yup.string().required("Password is a required field").matches(/^(?=.*[a-z])(?=.*\d)(?=.*[@$!%*#?&._-])[A-Za-z\d@$!%*#?&._-]{8,}$/,
                      "Use at least 8 characters containing at least 1 number, 1 lowercase letter, 1 special character in @$!%*#?&._-"),
            confirmPassword: yup.string().required("Confirm Password is a required field").oneOf([yup.ref('password'), null],'Passwords must match',),
        });
        return (
            <>
            {
            this.state.successMessage === true ?
                <div className="prelogin-content">
                    <div className="prelogin-thankyou">
                        <i className="d-inline-flex p-2 mr-3">
                           <Image src="email"/>
                        </i>
                        <h2>Thank you!</h2>
                        <h3>Password set successfully!</h3>
                        <p className="text-muted">Password has been set for your account.</p>
                        <button type="button" onClick={this.gotoLogin} className="btn btn-circle btn-secondary">Login Now</button>
                    </div>
                </div>
            :
            <div className="prelogin-content">
                <h4 className="login-welcome-text">Set new password</h4>
                <p>Create a new password for your account. If you have a problem with setting your password,
                    please send your queries to <a href = "mailto:helpdesk@qualdo.ai" >helpdesk@qualdo.ai</a></p>
                <div className="prelogin-form-container mt-5">
                    {this.state.errors !== '' ?
                           <div className="alert alert-sm has-close alert-danger alert-dismissible fade show modal-h" role="alert">
                              {this.state.errors}
                              <button type="button" className="close close-sm" onClick={() => this.hideAlert()} data-dismiss="alert" aria-label="Close"></button>
                           </div> : ''
                    }
                    <Formik
                        validationSchema={setSchema}
                        onSubmit={this.setPassword}
                        initialValues={{ password: '', confirmPassword: '' }}
                    >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                        isValid,
                    }) => (
                    <Form onSubmit={handleSubmit} className="login-form">
                        <Form.Group controlId="password">
                            <Form.Label>Password<span className="text-danger">*</span></Form.Label>
                            <InputGroup bsPrefix="icon-input-group">
                                <i>
                                    <FontAwesomeIcon icon={faLock}/>
                                </i>
                                <Form.Control
                                      className="form-control-solid placeholder-no-fix form-group"
                                      type={this.state.passwordType}
                                      autoComplete="off"
                                      placeholder="Password"
                                      name="password"
                                      value={values.password}
                                      onBlur={handleBlur}
                                      onChange={handleChange}
                                      isInvalid={errors.password && touched.password}
                                />
                                <Form.Control.Feedback type="invalid">
                                        { touched.password && errors.password }
                                </Form.Control.Feedback>
                                <i className="security-eye">
                                        <FontAwesomeIcon onClick={this.changePasswordIcon}  icon={this.state.passwordIcon} className="security-eye"/>
                                    </i>
                            </InputGroup>
                        </Form.Group>
                        <Form.Group controlId="confirmPassword">
                            <Form.Label>Confirm Password<span className="text-danger">*</span></Form.Label>
                            <InputGroup bsPrefix="icon-input-group">
                                <i>
                                    <FontAwesomeIcon icon={faLock}/>
                                </i>
                                <Form.Control
                                      className="form-control-solid placeholder-no-fix form-group"
                                      type={this.state.confirmPasswordType}
                                      autoComplete="off"
                                      placeholder="Confirm Password"
                                      name="confirmPassword"
                                      value={values.confirmPassword}
                                      onBlur={handleBlur}
                                      onChange={handleChange}
                                      isInvalid={errors.confirmPassword && touched.confirmPassword}
                                />
                                <Form.Control.Feedback type="invalid">
                                        { touched.confirmPassword && errors.confirmPassword }
                                </Form.Control.Feedback>
                                <i className="security-eye">
                                        <FontAwesomeIcon icon={this.state.confirmPasswordIcon} onClick={this.changeConfirmPasswordIcon} className="security-eye"/>
                                </i>
                            </InputGroup>
                        </Form.Group>
                        <button type="submit" disabled={this.state.hideSubmitButton} className="btn btn-circle btn-secondary">Set Password</button>
                    </Form>
                     )}
                    </Formik>
                </div>
            </div>
           }
           </>
        );
    }
}

export default ResetForm;